import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// Admin-only guard — redirects vendors to /reddit
const AdminOnly = ({ children }: { children: React.ReactNode }) => {
    try {
        const userStr = window.localStorage.getItem('xentai_user');
        const user = userStr ? JSON.parse(userStr) : null;
        if (user?.role === 2) return <Navigate to="/reddit" replace />;
    } catch {}
    return <>{children}</>;
};

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const AppProfileListStyle1 = Loadable(lazy(() => import('views/application/users/list/Style1')));
const BlogList = Loadable(lazy(() => import('views/application/blog/BlogList')));
const BlogDetail = Loadable(lazy(() => import('views/application/blog/BlogDetail')));
const Analytics = Loadable(lazy(() => import('views/application/analytics/Analytics')));
const RedditDashboard = Loadable(lazy(() => import('views/application/reddit/RedditDashboard')));
const Installs = Loadable(lazy(() => import('views/application/installs/Installs')));
const Engagement = Loadable(lazy(() => import('views/application/engagement/Engagement')));
const ReadinessConfig = Loadable(lazy(() => import('views/application/readiness-config/ReadinessConfig')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/list',
            element: <AdminOnly><AppProfileListStyle1 /></AdminOnly>
        },
        {
            path: '/dashboard/default',
            element: <AdminOnly><DashboardDefault /></AdminOnly>
        },
        {
            path: '/blog/list',
            element: <AdminOnly><BlogList /></AdminOnly>
        },
        {
            path: '/blog/:id',
            element: <AdminOnly><BlogDetail /></AdminOnly>
        },
        {
            path: '/analytics',
            element: <AdminOnly><Analytics /></AdminOnly>
        },
        {
            path: '/installs',
            element: <AdminOnly><Installs /></AdminOnly>
        },
        {
            path: '/engagement',
            element: <AdminOnly><Engagement /></AdminOnly>
        },
        {
            path: '/readiness-config',
            element: <AdminOnly><ReadinessConfig /></AdminOnly>
        },
        {
            path: '/reddit',
            element: <RedditDashboard />
        }
    ]
};

export default MainRoutes;
